module.exports = new __parcel__URL__("email-icon.c914d7fc.svg").toString();